// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AboutMe_wrapper__25029","heading":"AboutMe_heading__JJrqA","trainerAttributesBox":"AboutMe_trainerAttributesBox__gQIbx","attributesText":"AboutMe_attributesText__2H3bK"};